import $api from "../Api";
import Endpoints from "../Endpoints";
import normalizeBaseResult from "../helpers/baseResult";

/**
 * VKN/TCKN için e-Fatura mükellefiyetini ve alias bilgisini kontrol eder.
 *
 * @param {{ taxNumber: string, alias?: string|null, invoiceDateUtc?: string|null }} form
 */
export const Check = async (form) => {
  const response = await $api.post(Endpoints.EInvoiceRecipient.Check(), form);
  return normalizeBaseResult(response);
};

export default {
  Check,
};
